/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // Porfolio Slider Lightbox
  document.addEventListener("DOMContentLoaded", function () {
    const lightboxLinks = Array.from(document.querySelectorAll('.column__image a')).filter(link => {
      const img = link.querySelector('img');
      return img && /\.(jpe?g|png|webp)$/i.test(link.href);
    });

    if (lightboxLinks.length > 0) {
      lightboxLinks.forEach(link => link.classList.add('lightbox-enabled'));

      const lightbox = GLightbox({
        selector: 'a.lightbox-enabled'
      });
    }
  });

  // Slider Mobile Arrows
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 768) return;

    const sliderSelectors = '.grid--slider, .grid--mobile-slider';

    function enhanceSlider(slider) {
      if (!slider || slider.dataset.arrowsInjected === 'true') return;

      let wrapper = slider.closest('grid-slider');
      if (!wrapper) {
        wrapper = document.createElement('grid-slider');
        wrapper.setAttribute('align-arrows', '');
        slider.parentNode.insertBefore(wrapper, slider);
        wrapper.appendChild(slider);
      }

      if (wrapper.querySelector('.slider__arrows')) return;

      const arrows = document.createElement('div');
      arrows.className = 'slider__arrows';

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'slider__button slider__button--prev';
      prev.setAttribute('data-button-arrow', '');
      prev.setAttribute('data-button-prev', '');
      prev.setAttribute('aria-label', 'Previous');
      prev.textContent = 'Previous';
      prev.disabled = true;

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'slider__button slider__button--next';
      next.setAttribute('data-button-arrow', '');
      next.setAttribute('data-button-next', '');
      next.setAttribute('aria-label', 'Next');
      next.textContent = 'Next';

      arrows.appendChild(prev);
      arrows.appendChild(next);
      wrapper.appendChild(arrows);

      const items = Array.from(slider.querySelectorAll('.grid-item'));

      prev.addEventListener('click', () => {
        const scrollLeft = slider.scrollLeft;

        // Find the first item that is fully or partially visible
        const currentIndex = items.findIndex(item => item.offsetLeft >= scrollLeft - 1);
        const prevItem = items[Math.max(0, currentIndex - 1)];

        if (prevItem) {
          slider.scrollTo({ left: prevItem.offsetLeft, behavior: 'smooth' });
        }
      });

      next.addEventListener('click', () => {
        const scrollLeft = slider.scrollLeft;
        const containerWidth = slider.offsetWidth;

        // Find the first item that starts beyond the visible area
        const nextItem = items.find(item => item.offsetLeft > scrollLeft + 1);

        if (nextItem) {
          slider.scrollTo({ left: nextItem.offsetLeft, behavior: 'smooth' });
        }
      });

      slider.addEventListener('scroll', () => {
        const scrollLeft = slider.scrollLeft;
        const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
        prev.disabled = scrollLeft <= 0;
        next.disabled = scrollLeft >= maxScrollLeft - 10;
      });

      slider.dataset.arrowsInjected = 'true';
    }

    // Enhance existing visible sliders immediately
    document.querySelectorAll(sliderSelectors).forEach(slider => {
      if (slider.offsetParent !== null) enhanceSlider(slider);
    });

    // Listen for tab buttons
    document.querySelectorAll('[data-tab], .tabs__button').forEach(tabBtn => {
      tabBtn.addEventListener('click', () => {
        setTimeout(() => {
          document.querySelectorAll(sliderSelectors).forEach(slider => {
            if (slider.offsetParent !== null && slider.dataset.arrowsInjected !== 'true') {
              enhanceSlider(slider);
            }
          });
        }, 100); // small delay to allow tab to render
      });
    });

    // Also use MutationObserver for dynamically added sliders
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches(sliderSelectors)) {
            enhanceSlider(node);
          } else {
            node.querySelectorAll?.(sliderSelectors).forEach(enhanceSlider);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });


  document.addEventListener('DOMContentLoaded', () => {
    const quantitySelector = '.cart__quantity-field[data-minimum-order-amount]';

    function getMinimum(input) {
      return parseInt(input.dataset.minimumOrderAmount || input.min || '1', 10) || 1;
    }

    function getCartItem(input) {
      return input.closest('.cart__item');
    }

    function getMessage(input) {
      const cartItem = getCartItem(input);
      return cartItem ? cartItem.querySelector('[data-minimum-order-message]') : null;
    }

    function showMinimumMessage(input, minimum) {
      const message = getMessage(input);
      if (!message) return;

      message.textContent = `This product requires a minimum order of ${minimum}`;
      message.hidden = false;
    }

    function hideMinimumMessage(input) {
      const message = getMessage(input);
      if (message) message.hidden = true;
    }

    function clampCartQuantity(input, dispatchEvents = false) {
      if (!input || !input.matches(quantitySelector)) return;

      const minimum = getMinimum(input);
      const current = parseInt(input.value, 10);

      input.min = minimum;
      input.setAttribute('min', minimum);

      // Allow clearing while typing, but fix it on blur/change.
      if (input.value === '') return;

      if (!current || current < minimum) {
        input.value = minimum;
        showMinimumMessage(input, minimum);

        if (dispatchEvents) {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        return;
      }

      if (minimum > 1 && current === minimum) {
        showMinimumMessage(input, minimum);
      } else {
        hideMinimumMessage(input);
      }
    }

    // Capture phase: run before most cart drawer AJAX handlers.
    document.addEventListener('change', (event) => {
      if (event.target.matches(quantitySelector)) {
        clampCartQuantity(event.target, false);
      }
    }, true);

    document.addEventListener('blur', (event) => {
      if (event.target.matches(quantitySelector)) {
        clampCartQuantity(event.target, true);
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches(quantitySelector)) {
        clampCartQuantity(event.target, false);
      }
    }, true);

    // Initial cart drawer/page state
    document.querySelectorAll(quantitySelector).forEach((input) => {
      clampCartQuantity(input, false);
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const checkbox = document.querySelector('[data-cart-acceptance-checkbox]');
    const buttonsWrapper = document.querySelector('[data-cart-checkout-buttons]');
    const checkoutButton = document.querySelector('[name="checkout"]');

    if (!checkbox || !buttonsWrapper) return;

    function updateCartTermsState() {
      const accepted = checkbox.checked;

      buttonsWrapper.classList.toggle('cart__buttons--disabled', !accepted);

      if (checkoutButton) {
        checkoutButton.toggleAttribute('disabled', !accepted);
      }
    }

    checkbox.addEventListener('change', updateCartTermsState);
    updateCartTermsState();
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
